(function ($, window, document) {
	var syncApi = window.abiOriginalTabLinksSync || {};
	var rootSelector = '.p-original__tab-links';
	var itemSelector = rootSelector + ' .c-tabs--primary .items';
	var buttonSelector = itemSelector + ' button[role="tab"]';
	var panelSelector = '.tab-content-panel';
	var eventNamespace = '.abiOriginalTabLinksSync';

	function getButtons() {
		return $(buttonSelector);
	}

	function getItems() {
		return $(itemSelector);
	}

	function getPanels() {
		return $(panelSelector);
	}

	function getPanelById(target) {
		var matchedPanel = null;

		getPanels().each(function () {
			if (this.id === String(target)) {
				matchedPanel = this;
				return false;
			}
		});

		return $(matchedPanel);
	}

	function getButtonsByTarget(target) {
		return getButtons().filter(function () {
			return $(this).data('target') === target;
		});
	}

	function syncPanelsAria() {
		var labelledTargets = {};

		getPanels().attr('role', 'tabpanel');

		getButtons().each(function () {
			var $button = $(this);
			var target = $button.data('target');
			var $panel;

			if (!target || labelledTargets[target]) {
				return;
			}

			$panel = getPanelById(target);
			if (!$panel.length) {
				return;
			}

			$panel.attr('aria-labelledby', $button.attr('id'));
			labelledTargets[target] = true;
		});
	}

	function activateTarget(target) {
		var $matchedButtons;
		var $targetPanel;

		if (!target) {
			return;
		}

		$matchedButtons = getButtonsByTarget(target);
		if (!$matchedButtons.length) {
			return;
		}

		getItems().removeClass('active');
		getButtons()
			.attr('aria-selected', 'false')
			.attr('tabindex', '-1');

		$matchedButtons.each(function () {
			var $button = $(this);

			$button.closest('.items').addClass('active');
			$button.attr('aria-selected', 'true').attr('tabindex', '0');
		});

		getPanels().removeClass('is-active');
		$targetPanel = getPanelById(target);
		if ($targetPanel.length) {
			$targetPanel.addClass('is-active');
		}

		syncApi.activeTarget = target;
		syncPanelsAria();
	}

	function resolveInitialTarget() {
		var storedTarget = syncApi.activeTarget;
		var resolvedTarget = null;

		if (storedTarget && getButtonsByTarget(storedTarget).length) {
			return storedTarget;
		}

		getButtons().each(function () {
			var $button = $(this);
			var target = $button.data('target');

			if (!resolvedTarget && $button.closest('.items').hasClass('active') && target) {
				resolvedTarget = target;
			}
		});

		if (resolvedTarget) {
			return resolvedTarget;
		}

		getButtons().each(function () {
			var target = $(this).data('target');

			if (target) {
				resolvedTarget = target;
				return false;
			}
		});

		return resolvedTarget;
	}

	function scrollToContentIfNeeded(target) {
		var $panel = getPanelById(target);
		if (!$panel.length) {
			return;
		}

		var headerHeight = 0;
		var isSp = window.matchMedia('(max-width: 767px)').matches;
		if (!isSp) {
			var headerEl = document.querySelector('.l-header');
			if (headerEl) {
				headerHeight = headerEl.offsetHeight;
			}
		}

		var panelTop = $panel.offset().top - headerHeight;
		var scrollTop = $(window).scrollTop();

		if (panelTop < scrollTop) {
			var $firstTabLinks = $(rootSelector).first();
			var scrollTarget = $firstTabLinks.length
				? $firstTabLinks.offset().top - headerHeight
				: panelTop;

			$('html, body').animate({
				scrollTop: Math.max(0, scrollTarget)
			}, 400);
		}
	}

	function bindEvents() {
		$(document)
			.off('click' + eventNamespace, buttonSelector)
			.on('click' + eventNamespace, buttonSelector, function () {
				var target = $(this).data('target');
				activateTarget(target);
				scrollToContentIfNeeded(target);
			});

		$(document)
			.off('keydown' + eventNamespace, buttonSelector)
			.on('keydown' + eventNamespace, buttonSelector, function (e) {
				var $currentButton = $(this);
				var $sectionButtons = $currentButton.closest(rootSelector).find('button[role="tab"]');
				var index = $sectionButtons.index($currentButton);
				var $nextButton;

				switch (e.key) {
					case 'ArrowRight':
					case 'ArrowDown':
						e.preventDefault();
						$nextButton = $sectionButtons.eq((index + 1) % $sectionButtons.length);
						break;
					case 'ArrowLeft':
					case 'ArrowUp':
						e.preventDefault();
						$nextButton = $sectionButtons.eq((index - 1 + $sectionButtons.length) % $sectionButtons.length);
						break;
					case 'Home':
						e.preventDefault();
						$nextButton = $sectionButtons.first();
						break;
					case 'End':
						e.preventDefault();
						$nextButton = $sectionButtons.last();
						break;
					default:
						return;
				}

				if ($nextButton && $nextButton.length) {
					$nextButton.focus();
					activateTarget($nextButton.data('target'));
				}
			});

		if (!syncApi.isEditorBound) {
			document.addEventListener('shopify:section:load', function () {
				syncApi.init();
			});
			syncApi.isEditorBound = true;
		}
	}

	function init() {
		var initialTarget;

		syncPanelsAria();
		initialTarget = resolveInitialTarget();

		if (initialTarget) {
			activateTarget(initialTarget);
		}
	}

	syncApi.activeTarget = syncApi.activeTarget || null;
	syncApi.activateTarget = activateTarget;
	syncApi.init = init;
	window.abiOriginalTabLinksSync = syncApi;

	if (!syncApi.isBound) {
		bindEvents();
		syncApi.isBound = true;
	}

	$(function () {
		syncApi.init();
	});
})(jQuery, window, document);
